import { Box } from "@mui/material";
import AccordionSection from "./AccordionSection";
import CtaSection from "./CtaSection";
import GradientFramedLayout from "components/v3/layouts/GradientFramedLayout";
import OverviewSection from "./OverviewSection";
import TitleSection from "./TitleSection";
import VideoSection from "./VideoSection";

const WelcomePage = () => {
  return (
    <GradientFramedLayout showHeader={false}>
      <Box
        sx={{
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          gap: {
            xs: "10px",
            md: 8
          },
          maxWidth: "1280px"
        }}
      >
        <TitleSection />
        <OverviewSection />
        <VideoSection />
        <AccordionSection />
        <CtaSection />
      </Box>
    </GradientFramedLayout>
  );
};

export default WelcomePage;
